import React, { useState, useEffect } from 'react';
import styles from './ProgressBar.module.css';

const ProgressBar = ({ isLoading = false, progress = 0 }) => {

  return (
    <div className={`${styles.progress} ${isLoading ? styles["progress--indeterminate"] : ''}`}  style={{"--width": `${progress}%`}}>
        <div className={styles.bar}></div>
    </div>
  );
};

export default ProgressBar;